import { Component } from '@angular/core';

@Component({
    selector: 'cr-avid-quiet-svg',
    templateUrl: './quiet-svg.component.html',
    styleUrls: ['./quiet-svg.component.scss'],
})
export class QuietSvgComponent {}
